import { render, staticRenderFns } from "./Linea-servicios.vue?vue&type=template&id=b966f35a"
import script from "./Linea-servicios.vue?vue&type=script&lang=js"
export * from "./Linea-servicios.vue?vue&type=script&lang=js"
import style0 from "./Linea-servicios.vue?vue&type=style&index=0&id=b966f35a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports